import { render, staticRenderFns } from "./videoAdd.vue?vue&type=template&id=5093aa47&"
import script from "./videoAdd.vue?vue&type=script&lang=js&"
export * from "./videoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports